// Klubora design tokens — source of truth: docs/brand/03-visual-identity.md
// Used as 100% inline styles in apps/platform.

export const colors = {
  // Surfaces
  ink: "#0E1116",
  paper: "#FAFAF7",
  fog: "#E8E8E3",
  stone: "#6B6B66",
  stoneSoft: "#9A9A95",
  graphite: "#1F2228",
  white: "#FFFFFF",

  // Brand accent (sole indigo, used sparingly)
  indigo: "#3D4EE8",
  indigoSoft: "rgba(61, 78, 232, 0.08)",

  // Semantic
  success: "#1E8E5C",
  successSoft: "rgba(30, 142, 92, 0.10)",
  warning: "#B7791F",
  warningSoft: "rgba(183, 121, 31, 0.10)",
  error: "#C44545",
  errorSoft: "rgba(196, 69, 69, 0.10)",
} as const;

export const radius = {
  xs: 4,
  sm: 6,
  md: 10,
  lg: 14,
  pill: 999,
} as const;

export const shadow = {
  xs: "0 1px 2px 0 rgba(14, 17, 22, 0.04)",
  sm: "0 2px 4px -1px rgba(14, 17, 22, 0.06), 0 1px 2px -1px rgba(14, 17, 22, 0.04)",
  md: "0 8px 16px -4px rgba(14, 17, 22, 0.08), 0 2px 4px -2px rgba(14, 17, 22, 0.04)",
  lg: "0 24px 48px -12px rgba(14, 17, 22, 0.18), 0 8px 16px -8px rgba(14, 17, 22, 0.08)",
} as const;

export const space = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
  xxxl: 32,
  xxxxl: 48,
} as const;

export const fontSize = {
  xs: "11px",
  sm: "12px",
  md: "13px",
  base: "14px",
  lg: "16px",
  xl: "18px",
  h2: "20px",
  h1: "28px",
  display: "32px",
} as const;

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  // Per brand manual, NEVER use 700.
} as const;

export const ease = "cubic-bezier(0.32, 0.72, 0, 1)";

export const lifecycleBadgeColor: Record<string, { bg: string; fg: string; dot: string }> = {
  prospect: { bg: colors.fog, fg: colors.stone, dot: colors.stone },
  trial: { bg: colors.indigoSoft, fg: colors.indigo, dot: colors.indigo },
  active: { bg: colors.successSoft, fg: colors.success, dot: colors.success },
  delinquent: { bg: colors.warningSoft, fg: colors.warning, dot: colors.warning },
  suspended: { bg: colors.errorSoft, fg: colors.error, dot: colors.error },
  churned: { bg: colors.fog, fg: colors.stone, dot: colors.stone },
  archived: { bg: colors.fog, fg: colors.stone, dot: colors.stone },
};

export const fontFamily = "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
export const fontFamilyMono = "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace";
